module.exports = __webpack_public_path__ + "media/fresh/university-06914760.svg";